import InitSettingsLogic from "./Settings.logic";
import { useState } from "react";
import { t } from "i18next";
import SwitchComponent from "../../translation/Switch/Switch.component";

const SettingsComponent: React.FC = () => {
    const { client, onLogout, onTrainings, onHome, togglePushNotifications } = InitSettingsLogic();
    const [activeTab, setActiveTab] = useState("Podešavanja");



    return (
        <div className="page-container">
            <h1 className="text-align-center" style={{ marginBottom: 24 }}>{`${t("Podešavanja")}`}</h1>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: '16px' }}>
                <div style={{ textAlign: 'center' }}>
                    <label style={{ display: 'block', marginBottom: 6 }}>{`${t("Jezik")}`}</label>
                    <SwitchComponent></SwitchComponent>
                </div>

                {client?.user && (
                    <button
                        className="btn-secondary"
                        onClick={() => togglePushNotifications(client.user.disabledPushNotifications)}
                    >
                        {client.user.disabledPushNotifications ? `${t("Uključi obaveštenja")}` : `${t("Isključi obaveštenja")}`}
                    </button>
                )}

                <button
                    className="btn-danger"
                    onClick={onLogout}
                >
                    {`${t("Odjavi se")}`}
                </button>
            </div>


            {/* Bottom Navigation Tabs */}
            <div style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                backgroundColor: 'var(--white)',
                borderTop: '1px solid var(--border)',
                display: 'flex',
                justifyContent: 'space-around',
                padding: '10px 8px',
                gap: '8px',
                zIndex: 100
            }}>
                <button
                    style={{
                        flex: 1,
                        maxWidth: 160,
                        padding: '10px 12px',
                        background: activeTab === "Početna" ? 'var(--secondary)' : 'transparent',
                        color: 'var(--text)',
                        fontWeight: activeTab === "Početna" ? 600 : 400,
                        borderRadius: 10,
                    }}
                    onClick={() => { setActiveTab("Početna"); onHome() }}
                >
                    {`${t("Početna")}`}
                </button>
                <button
                    style={{
                        flex: 1,
                        maxWidth: 160,
                        padding: '10px 12px',
                        background: activeTab === "Kalendar" ? 'var(--secondary)' : 'transparent',
                        color: 'var(--text)',
                        fontWeight: activeTab === "Kalendar" ? 600 : 400,
                        borderRadius: 10,
                    }}
                    onClick={() => {
                        setActiveTab("Kalendar");
                        onTrainings();
                    }}
                >
                    {`${t("Kalendar")}`}
                </button>
                <button
                    style={{
                        flex: 1,
                        maxWidth: 160,
                        padding: '10px 12px',
                        background: activeTab === "Podešavanja" ? 'var(--secondary)' : 'transparent',
                        color: 'var(--text)',
                        fontWeight: activeTab === "Podešavanja" ? 600 : 400,
                        borderRadius: 10,
                    }}
                    onClick={() => {
                        setActiveTab("Podešavanja");
                    }}
                >
                    {`${t("Podešavanja")}`}
                </button>
            </div>
        </div>
    );
}

export default SettingsComponent;
